module.exports = __webpack_public_path__ + "img/fwpt3.19361483.webp";